import {SERVERS_CONFIG} from '../config/network.settings';

export function hasCustomEndpointConfig(env: string): boolean {
  return env in SERVERS_CONFIG;
}

export function decodeEndpoint(encodedEndpoint: string): string {
  return atob(encodedEndpoint);
}

export function decodeEndpointList(encodedEndpoints: string[]): string[] {
  return encodedEndpoints.map(endpoint => decodeEndpoint(endpoint));
}

export function buildUrl(endpoint: string, path?: string): string {
  const cleanEndpoint = endpoint.endsWith('/')
    ? endpoint.slice(0, -1)
    : endpoint;
  return path
    ? `${cleanEndpoint}/${path.startsWith('/') ? path.slice(1) : path}`
    : `${cleanEndpoint}/`;
}

export function selectEndpoint(endpoints: string[]): string {
  const randomIndex = Math.floor(Math.random() * endpoints.length);
  return endpoints[randomIndex];
}

export function getEndpoints(
  type: 'base' | 'lt' | 'sports' | 'im' | 'quick3d' | 'lqi' | 'loi',
  env: string,
  fallbackBaseUrl: string,
  fallbackSpecificUrl?: string,
): string[] {
  if (hasCustomEndpointConfig(env)) {
    const config = SERVERS_CONFIG[env];
    let encodedEndpoints: string[] | undefined;

    switch (type) {
      case 'base':
        encodedEndpoints = config.baseApiEndpoints;
        break;
      case 'lt':
        encodedEndpoints = config.ltapiEndpoints;
        break;
      case 'sports':
        encodedEndpoints = config.sportsEndpoints;
        break;
      case 'im':
        encodedEndpoints = config.imEndpoints;
        break;
      case 'quick3d':
        encodedEndpoints = config.quick3dEndpoints;
        break;
      case 'lqi':
        encodedEndpoints = config.lqiEndpoints;
        break;
      case 'loi':
        encodedEndpoints = config.loiEndpoints;
        break;
    }

    // 如果配置列表为空，回退到环境变量
    if (!encodedEndpoints || encodedEndpoints.length === 0) {
      const envVar =
        type === 'base'
          ? fallbackBaseUrl
          : fallbackSpecificUrl || fallbackBaseUrl;
      return [envVar];
    }

    return decodeEndpointList(encodedEndpoints);
  } else {
    const envVar =
      type === 'base'
        ? fallbackBaseUrl
        : fallbackSpecificUrl || fallbackBaseUrl;
    return [envVar];
  }
}
